import React, { useState, useEffect } from "react";
import { Box, Typography, Paper, TextField, Button, Snackbar } from "@mui/material";
import axios from "axios";
import "./PL.css";

const CallLog = ({ lead }) => {
  const [note, setNote] = useState("");
  const [loading, setLoading] = useState(false);
  const [snackOpen, setSnackOpen] = useState(false);
  const [callLogs, setCallLogs] = useState([]);

  // 🔄 Fetch existing logs on mount
  useEffect(() => {
    const fetchLogs = async () => {
      try {
        const res = await axios.post("https://be.corebankers.in/telecalling_pl_call_log", {
          random_id: lead.random_id,
        });
        console.log("📥 Existing logs fetched:", res.data.existing_logs);
        setCallLogs(res.data.existing_logs || []);
      } catch (err) {
        console.error("❌ Failed to fetch call logs:", err);
      }
    };

    if (lead?.random_id) fetchLogs();
  }, [lead]);

  // 📝 Add new log
  const handleAddLog = async () => {
    if (!note.trim()) {
      console.log("🛑 Note is empty. Skipping submission.");
      return;
    }

    const payload = {
      random_id: lead.random_id,
      notes: note,
      timestamp: new Date().toISOString(),
    };

    console.log("📤 Submitting call log payload:", payload);

    try {
      setLoading(true);
      const res = await axios.post("https://be.corebankers.in/telecalling_pl_call_log", payload);
      console.log("✅ Response from backend:", res);

      if (res.status === 200 || res.status === 201) {
        console.log("📥 Call log saved successfully. Updating UI...");
        setNote("");
        setSnackOpen(true);
        setCallLogs(res.data.existing_logs || []);
      } else {
        console.warn("⚠️ Unexpected response status:", res.status);
      }
    } catch (err) {
      console.error("❌ Error while saving call log:", err);
    } finally {
      setLoading(false);
    }
  };

  // 🕒 Format timestamp to YYYY-MM-DD HH:mm
  const formatDateTime = (ts) => {
  const dateObj = new Date(ts);
  const day = String(dateObj.getDate()).padStart(2, "0");
  const month = String(dateObj.getMonth() + 1).padStart(2, "0");
  const year = dateObj.getFullYear();
  const time = dateObj.toLocaleTimeString([], { hour: "2-digit", minute: "2-digit" });

  return `${day}-${month}-${year} ${time}`;
};

  return (
    <Paper elevation={3} sx={{ p: 2, borderRadius: 3 }}>
      <Typography variant="subtitle1" mb={2} fontWeight="bold">
        📞 Lead Logs
      </Typography>

      {[...callLogs]
        .sort((a, b) => new Date(a.timestamp) - new Date(b.timestamp)) // Oldest first
        .map((log, idx) => (
          <Box
            key={idx}
            mb={2}
            p={1.5}
            borderLeft="3px solid #1976d2"
            sx={{ bgcolor: "grey.50", borderRadius: 1 }}
          >
            <Typography variant="body2">
              {formatDateTime(log.timestamp)} - {log.notes}
            </Typography>
          </Box>
        ))}

      {callLogs.length === 0 && (
        <Typography variant="body2" color="text.secondary">
          No call logs available.
        </Typography>
      )}

      <Box mt={2}>
        <TextField
          label="Add Call Notes"
          fullWidth
          multiline
          rows={3}
          variant="outlined"
          size="small"
          value={note}
          onChange={(e) => {
            console.log("✍️ Note updated:", e.target.value);
            setNote(e.target.value);
          }}
        />
        <Button
          variant="contained"
          sx={{ mt: 1 }}
          onClick={handleAddLog}
          disabled={loading}
        >
          {loading ? "Saving..." : "Add Log"}
        </Button>
      </Box>

      <Snackbar
        open={snackOpen}
        autoHideDuration={3000}
        onClose={() => setSnackOpen(false)}
        message="Call log added successfully"
      />
    </Paper>
  );
};

export default CallLog;